import { GuardedDeletionService, ReasonService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ReasonCreateDto,
  ReasonDto,
  ReasonExcelDownloadDto,
  ReasonUpdateDto,
} from '../proxy/general/dtos/reason';
import { REASON_CONFIG, REASON_FIELDS } from './reason.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-reason',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ReasonService, ConfirmationService],
  templateUrl: './reason.html',
  styleUrl: './reason.scss',
})
export class Reason extends BaseCrudComponent<
  ReasonDto,
  ReasonCreateDto,
  ReasonUpdateDto,
  ReasonExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ReasonService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Reason', ids),
  };
  config = REASON_CONFIG;
  fields = REASON_FIELDS;

  protected prepareUpdateDto(data: any, selected: ReasonDto): ReasonUpdateDto {
    return {
      name: data.name,
      code: data.code,
      reasonGroupBiId: data.reasonGroupBiId,
      isVisible: data.isVisible,
      isProductive: data.isProductive,
      isForDisableResourceTemporarily: data.isForDisableResourceTemporarily,
      isEnabledForLiquidation: data.isEnabledForLiquidation,
      canDeprocessHarvestActivityReport: data.canDeprocessHarvestActivityReport,
      reasonGroupId: data.reasonGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Reason';
  }
}
